import React, { useState, useEffect } from 'react'
import styled from 'styled-components'


const Jumbotron = styled(
    ({ className, children, title, navs }) => {

        return (
            <div className={className}>
                <div className="header">
                    {title && <div className="title">{title}</div>}
                    {navs && <div className="navs">{navs}</div>}
                </div>
                <div className="body">
                    {children}
                </div>
            </div>
        )
    })`
        display: flex;
        flex-direction: row;
        margin-bottom: 10px;

        .title{
            font-size: 32px;
            font-weight: 700;
            line-height: 40px;
            color: var(--color-white, white);
        }

        .body {
            text-align: right;

            .info{

                font-size: 32px;
                font-weight: 700;
                line-height: 40px;
                color: var(--color-white, white);
                margin-right: 1.5rem;
                margin-top: 4px;
            }

            .title {
                font-size: 14px;
                font-weight: 400;
                color: var(--color-label, lightblue);
                
                line-height: 16px;
                
            }

        }

        .navs {
            padding-top: 0.5rem;
            padding-bottom: 0.5rem;
            
        }

        div {
            flex-direction: column;
            flex: 1;
        }

    `


export default Jumbotron